export default __webpack_public_path__ + "static/media/pricePremium.30568fa6.svg";